var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-result-body"},[_c('el-result',{attrs:{"icon":_vm.icon,"title":_vm.title,"subTitle":_vm.subTitle}},[_c('template',{slot:"extra"},[_vm._t("default")],2)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }